import type { RedirectRequest } from '@azure/msal-browser'
import { environment } from '../config/environment'

interface MsalConfigType {
  auth: {
    clientId: string
    authority: string
    redirectUri: string
    logoutRedirectUri: string
  }
  cache: {
    cacheLocation: string
    storeAuthStateInCookie: boolean
  }
}

// Cache the config after first creation
let _cachedConfig: MsalConfigType | null = null

// Getter function that reads environment values lazily
const getMsalConfig = (): MsalConfigType => {
  if (_cachedConfig) {
    return _cachedConfig
  }

  const clientId = environment.msalClientId
  const tenantId = environment.msalTenantId

  _cachedConfig = {
    auth: {
      clientId: clientId,
      authority: `https://login.microsoftonline.com/${tenantId}`,
      redirectUri: '/',
      logoutRedirectUri: '/',
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false,
    },
  }

  return _cachedConfig
}

// Export as a getter property so it's evaluated when accessed
export const msalConfig = new Proxy({} as MsalConfigType, {
  get(_, prop) {
    return getMsalConfig()[prop as keyof MsalConfigType]
  },
})

export const loginRequestApi: RedirectRequest = {
  get scopes() {
    return [environment.msalApiScope]
  },
} as RedirectRequest

export const loginRequest: RedirectRequest = {
  scopes: ['User.Read'],
}

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
}
